import { ChevronDown } from "lucide-react";

interface VersionBadgeProps {
  versionNumber: string;
  onClick: () => void;
}

export function VersionBadge({ versionNumber, onClick }: VersionBadgeProps) {
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-0.5 rounded-full border border-border bg-muted/50 px-2 py-0.5 text-[10px] font-medium text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
      title="View version history"
    >
      v{versionNumber}
      <ChevronDown className="h-2.5 w-2.5" />
    </button>
  );
}
